<div  class="container">
  <mat-accordion  class="custom-accordion box-appearance m-t-20">
    <mat-expansion-panel (closed)="onClosePanel(item)" (opened)="onOpenPanel(item)" [expanded]="item.id === 'TaskDetail'" *ngFor="let item of rightViewItems; let i=index">
      <mat-expansion-panel-header>
        <mat-panel-title class="header w-p-100">
          {{item.title}}
        </mat-panel-title>
      </mat-expansion-panel-header>
      <ng-template matExpansionPanelContent>
        <particle-task-detail-view
          *ngIf="item.id === 'TaskDetail'"
          [data]="data"
          [taskMenuItems]="taskMenuItemsMapper"
          (selectedMenuChange$)="onSelectedMenuChanges($event)"></particle-task-detail-view>

        <!-- ITP-E-177-04 — a support ticket's live sessions: who helped and when; Disconnect / Reconnect. -->
        <particle-task-connection-history
          *ngIf="item.id === 'ConnectionHistory'"
          [ticketId]="data?.input?.card?.id"
          [history]="connectionHistory"></particle-task-connection-history>

        <app-due-date-task-return-details-view
          *ngIf = "item.id === 'DueDateTaskReturnDetails'"
          [dueDateReturnDetails]="dueDateReturnDetails"
        >
        </app-due-date-task-return-details-view>
      </ng-template>
    </mat-expansion-panel>
  </mat-accordion>
</div>
